/* eslint-disable no-param-reassign */

let cachedCtxtData = null;
let cachedSvcUrl = null;

export default {
  // /////////////////
  // generals ops
  // /////////////////
  hasLocalhost(hostname) {
    return Boolean(
      hostname.match(/localhost/) ||
        hostname.match(/127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/),
    );
  },
  hasHostname(hostname) {
    return Boolean(hostname.includes(window.location.hostname));
  },

  isRunningOnLocalhost() {
    return this.hasLocalhost(window.location.hostname);
  },
  isRunningOnProd() {
    return !this.isLocal();
  },

  svcUrl() {
    if (!cachedSvcUrl) {
      cachedSvcUrl = process.env.VUE_APP_BASE_URL
        ? process.env.VUE_APP_BASE_URL
        : 'https://app.implicit.io/';
      // if (this.isRunningOnLocalhost()) cachedSvcUrl = 'http://127.0.0.1:3000/';
    }
    return cachedSvcUrl;
  },

  log(str, obj1, obj2) {
    if (obj1 && obj2) {
      console.log(`[${new Date().toLocaleTimeString()}] ${str}`, obj1, obj2);
      return;
    }
    if (obj1) {
      console.log(`[${new Date().toLocaleTimeString()}] ${str}`, obj1);
      return;
    }
    console.log(`[${new Date().toLocaleTimeString()}] ${str}`);
  },
  trace(str, obj1, obj2) {
    if (obj1 && obj2) {
      console.trace(`[${new Date().toLocaleTimeString()}] ${str}`, obj1, obj2);
      return;
    }
    if (obj1) {
      console.trace(`[${new Date().toLocaleTimeString()}] ${str}`, obj1);
      return;
    }
    console.trace(`[${new Date().toLocaleTimeString()}] ${str}`);
  },

  // /////////////////
  // UI helpers
  // /////////////////
  app(cmp) {
    // $root is the router - so we need to go to its child
    if (cmp && cmp.$root && cmp.$root.$children) return cmp.$root.$children[0];
    return null;
  },
  layout(cmp) {
    const app = this.app(cmp);
    return app.$refs.routerView.$children[0];
  },
  setStatusMsg(cmp, msg) {
    cmp.$root.$emit('status-message', msg);
  },

  contextualNav(cmp, path, ctxtData = null) {
    cachedCtxtData = ctxtData;
    cmp.$router.push(path);
  },
  getNavContext() {
    const retVal = cachedCtxtData;
    cachedCtxtData = null;
    return retVal;
  },

  // /////////////////
  // better UI
  // /////////////////
  relativeTimeInHTML(givenDtAsStr) {
    const randomExtraNdx = givenDtAsStr.indexOf('Z-');
    if (randomExtraNdx !== -1) givenDtAsStr = givenDtAsStr.substring(0, randomExtraNdx + 1);
    // console.log(givenDtAsStr);
    const given = new Date(givenDtAsStr).getTime();
    const now = new Date().getTime();
    let gap = now - given;
    if (gap < 1000) return 'less than 1s ago';
    gap /= 1000;

    if (gap < 60) return `${Math.floor(gap)} seconds ago`;
    gap /= 60;

    if (gap < 2) return 'a minute ago';
    if (gap < 60) return `${Math.floor(gap)} minutes ago`;
    gap /= 60;

    if (gap < 2) return 'an hour ago';
    if (gap < 24) return `${Math.floor(gap)} hours ago`;
    gap /= 24;

    if (gap < 2) return 'yesterday';
    if (gap < 30) return `${Math.floor(gap)} days ago`;
    gap /= 30;

    if (gap < 2) return 'last month';
    if (gap < 12) return `${Math.floor(gap)} months ago`;
    gap /= 12;

    if (gap < 2) return 'last year';
    return `${Math.floor(gap)} years ago`;
  },
};
